import { TextBadge } from '@carvana/ds-badge';

export default function StockImageBadge() {
  return (
    <TextBadge
      className="absolute bottom-[8.33px] right-[8.33px] bg-canvas-overlay text-text-inverse"
      data-testid="why-buy-stock-image-badge"
      priority="muted"
      variant="subtle"
    >
      Stock image
    </TextBadge>
  );
}
